































import { Component, Prop, Vue } from 'vue-property-decorator';
import LayerControl from './LayerControl.vue';
import { R6Map } from '@/maps';
import FloorLayer from '@/maps/FloorLayer';

@Component({
  components: {
    LayerControl
  }
})
export default class Menu extends Vue {
  public solo(picked: FloorLayer) {
    picked.config.enabled = true;
    picked.config.opacity = 1;
    picked.parent!.floors.forEach((layer: any) => {
      if (layer !== picked) layer.config.enabled = false;
    });
  }
  public soloDrag(picked: FloorLayer) {
    if (picked.config.draggable) {
      picked.config.draggable = false;
      return;
    }
    picked.config.draggable = true;
    picked.parent!.floors.forEach((layer: any) => {
      if (layer !== picked) layer.config.draggable = false;
    });
  }

  public updateLayerKey(layer: any, key: string, value: any) {
    this.$store.commit('changeLayerKey', {
      layer,
      key,
      value
    });
    if (key === 'draggable') {
      if (value === true) {
        this.$store.commit('changeDraggable', false);
      }
      if (value === false) {
        let allFalse = this.$store.state.layers.every((one: any) => {
          return one.draggable === false;
        });
        if (allFalse) {
          this.$store.commit('changeDraggable', true);
        }
      }
    }
  }
}
